 
import { motion } from 'framer-motion';

const ExpiryWarningDialog = ({
    show,
    remainingTime,
    onCancelBooking,
    onContinue,
}) => {
    if (!show) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                className="bg-white rounded-2xl shadow-2xl max-w-sm w-full overflow-hidden"
            >
                <div className="bg-gradient-to-r from-amber-500 to-orange-500 px-6 py-5">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center">
                            <svg className="w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <div>
                            <h3 className="text-base font-bold text-white">Session Expiring Soon</h3>
                            <p className="text-white/80 text-xs">
                                {remainingTime ? `${remainingTime.minutes}:${remainingTime.seconds?.toString().padStart(2, '0')} remaining` : ''}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="p-6 space-y-4">
                    <p className="text-sm text-slate-600">
                        Your booking session is about to expire. If you don't complete payment, your order will be{' '}
                        <strong className="text-red-600">automatically cancelled</strong>.
                    </p>
                    <div className="flex gap-3">
                        <button
                            onClick={onCancelBooking}
                            className="flex-1 py-3 border border-slate-200 text-slate-600 rounded-xl hover:bg-slate-50 font-semibold text-sm transition-all hover:border-slate-300"
                        >
                            Cancel Booking
                        </button>
                        <button
                            onClick={onContinue}
                            className="flex-1 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl font-semibold text-sm shadow-md shadow-blue-200 hover:from-blue-700 hover:to-indigo-700 transition-all hover:scale-105 active:scale-95"
                        >
                            Continue
                        </button>
                    </div>
                </div>
            </motion.div>
        </div>
    );
};

export default ExpiryWarningDialog;